import styled from 'styled-components';

const DocumentsStyles = styled.section`
  padding: 0 ${props => props.theme.padding.inner} 4rem;
  overflow: hidden;

  .inner {
    max-width: ${props => props.theme.maxWidths.container};
    margin: auto;
    position: relative;
  }

  .content {
    margin: 0 -${props => props.theme.padding.inner};
    padding: 3.475rem 2rem 7.1875rem;
    background: ${props => props.theme.colors.blue10};

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: scale(1.1);
        transition: all 0.4s ease-in-out;
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }

    &-wrapper {
      margin: auto;
      max-width: ${props => props.theme.maxWidths.containerSmall};

      @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        max-width: ${props => props.theme.maxWidths.container};
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      margin: 0 -3rem;
      padding: 3.475rem 3.125rem 7.1875rem;
    }

    a {
      width: max-content;
      display: inline-block;
    }

    h2 {
      margin: 0;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      padding: 3.475rem 18rem 4.9375rem 6.5rem;
      margin-right: 13rem;

      p {
        max-width: 32rem;
        margin-bottom: 2rem;
      }
    }
  }

  .examples {
    box-shadow: ${props => props.theme.shadows.high};
    padding: 2.125rem 0 1.8125rem 2.3125rem;
    background: ${props => props.theme.colors.white};
    border-radius: ${props => props.theme.borderRadiuses.card};
    margin: -4.5rem auto 0;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transform: scale(1.1);
        transition: all 0.4s ease-in-out;
        transition-delay: 0.2s;
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
    }

    .active& {
      opacity: 1;
      transform: none;
    }

    h6 {
      margin: 0;
      color: ${props => props.theme.colors.claytonBlue};
      font-weight: 600;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        text-transform: uppercase;
        font-size: ${props => props.theme.type.h6};
        line-height: ${props => props.theme.lineHeights.h6};
        font-weight: 600;
        padding: 0.625rem 0;
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      margin: 0;
      width: 33%;
      max-width: 31rem;
      position: absolute;
      right: 0;
      top: 3.475rem;
      padding: 3.5625rem 4.1875rem 3.4375rem;
    }
  }
`;

export default DocumentsStyles;
